// MUI から Grid コンポーネントをインポート
import { Grid } from '@mui/material';
// MUI から Stack コンポーネントをインポート
import { Stack } from '@mui/material';
// React から useEffect フックをインポート
import { useEffect } from 'react';
// React から useMemo フックをインポート
import { useMemo } from 'react';
// react-hook-form から useForm フックをインポート
import { useForm } from 'react-hook-form';
// react-redux から useDispatch フックをインポート
import { useDispatch } from 'react-redux';
// 一般アンケートの型定義をインポート
import { GeneralEnquete, Question, QuestionState } from 'src/@types/generalEnquete';
// 言語設定フックをインポート
import useLocales from 'src/hooks/useLocales';
// Redux ストアセレクターをインポート
import { useAppSelector } from 'src/redux/store';
// エラー状態設定アクションをインポート
import { setHasAction5Error } from '../../../../store/enqueteGeneralAnswerSlice';
// 過去の回答リストコンポーネントをインポート
import { PreviousAnswersList } from '../../common/components/previous-answers-list/components/PreviousAnswersList';
// 質問説明ボックスコンポーネントをインポート
import { EnqueteAnswerDescriptionBox } from '../../type-general-question/components/tabs/question-and-answer/components/common/EnqueteAnswerDescriptionBox';
// 質問フォームスイッチャーコンポーネントをインポート
import EnqueteAnswerCompliaSurveyFormSwitcher from './EnqueteAnswerSpecialQuestionCompliaFormSwitcher';

// EnqueteAnswerSpecialQuestionCompliaFormAction5Tab コンポーネントを定義
const EnqueteAnswerSpecialQuestionCompliaFormAction5Tab: React.FC = () => {
  // react-hook-form のメソッドを初期化、変更モードで検証を設定
  const methods = useForm({ mode: 'onChange' });
  // Redux dispatch 関数を取得
  const dispatch = useDispatch();

  // 現在の言語設定を取得
  const { currentLang } = useLocales();

  // Redux ストアからアンケートアクション⑤詳細データを取得
  const surveyDetailAction5Data = useAppSelector((stateGeneral) => stateGeneral.enqueteAnswer.surveyDetailAction5Data);
  // Redux ストアから質問状態の配列を取得
  const questionStates: QuestionState[] = useAppSelector((stateGeneral) => stateGeneral.enqueteGeneralAnswerAction5.questionStates);
  // Redux ストアから質問配列を取得
  const questions: Question[] = useAppSelector((stateGeneral) => stateGeneral.enqueteGeneralAnswerAction5.questions);
  // アンケートフォームデータをメモ化して性能を最適化
  const memolizedEnqueteFormData = useMemo(() => surveyDetailAction5Data?.surveyFormData?.formData?.tabData[0], [surveyDetailAction5Data]) as GeneralEnquete;
  // 現在の言語に基づいて質問説明文を選択
  const questionDescription =
    currentLang.value === 'ja' ? memolizedEnqueteFormData?.questionDescriptionJpn : memolizedEnqueteFormData?.questionDescriptionEng;

  // アンケート回答入力時のバリデーション状態を保存しておく
  // フォームの検証状態が変わった時に Redux にエラー状態を dispatch
  useEffect(() => {
    // フォームが有効でない場合エラー状態を true に設定
    dispatch(setHasAction5Error(!methods.formState.isValid));
    // フォームの検証状態と dispatch 関数を依存配列に設定
  }, [methods.formState.isValid, dispatch]);

  // コンポーネントの JSX を返す
  return (
    // 縦方向のスタックコンポーネントをフォームとしてレンダリング
    <Stack component="form" sx={{ width: '100%' }}>
      {/* // Grid コンテナを縦方向カラムで設定 */}
      <Grid container direction="column" justifyContent="flex-start">
        {/* // Grid アイテムを全幅で設定 */}
        <Grid item xs={12} md={12}>
          {/* // 質問説明が存在する場合説明ボックスをレンダリング */}
          {questionDescription && questionDescription !== '' ? <EnqueteAnswerDescriptionBox questionDescription={questionDescription} /> : null}
        </Grid>
        {/* // 過去の回答リストコンポーネントをレンダリング */}
        <PreviousAnswersList />
        {/* // Grid アイテムを全幅で設定 */}
        <Grid item xs={12} md={12}>
          {/* // 質問配列が存在し、かつ長さが0より大きい場合 */}
          {questions !== undefined &&
            // 質問配列の長さが0より大きい場合
            questions.length > 0 &&
            // 質問配列をループ
            questions.map((question, index: number) => {
              // 各質問に対してフォームスイッチャーコンポーネントを返す
              return (
                // 質問フォームスイッチャーコンポーネントをレンダリング
                <EnqueteAnswerCompliaSurveyFormSwitcher
                  // フォームメソッドを渡す
                  methods={methods}
                  // 質問データを渡す
                  question={question}
                  // インデックスを渡す
                  index={index}
                  // 質問 ID をキーとして設定
                  key={question.id}
                  // 質問状態を渡す
                  questionStates={questionStates}
                />
              );
            })}
        </Grid>
      </Grid>
    </Stack>
  );
};

// EnqueteAnswerSpecialQuestionCompliaFormAction5Tab コンポーネントをデフォルトエクスポート
export default EnqueteAnswerSpecialQuestionCompliaFormAction5Tab;
